<template>
  <div :style="getElementStyle" v-loading="loading" v-if="data.properties.filed_content != 'Hide'">
    <el-row
      align="middle"
      v-if="!data.properties.hideLabel || data.properties.filed_content != 'Hide'"
    >
      <el-col
        :span="showLabel && !isDefalutPosq ? 4 : data.description ? 20 : 24"
        :style="computedStyles"
      >
        <label
          class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          for="text"
          v-if="hasLabel && !data.properties.hideLabel"
          style="margin-right: 5px"
        >
          {{ label || data.label }}
        </label>
        <span v-if="data.validations.required" style="color: red; font-weight: bold">*</span>
        <span>
          <el-popover
            v-if="data.description"
            placement="top-start"
            trigger="hover"
            :content="data.description"
          >
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </span>
      </el-col>
      <el-col :span="showLabel && !isDefalutPosq ? 12 : 24">
        <div v-if="!isView">
          <template
            v-if="data.integration_settings.selectedIntegrationFieldVariableType === 'select'"
          >
            <el-select
              v-model="computedSelectValue"
              placeholder="Select an option"
              @change="applyFormRules"
              :disabled="checkReadonly()"
              :style="getStyle"
            >
              <el-option
                v-for="(item, index) in integrationVariables"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template
            v-else-if="data.integration_settings.selectedIntegrationFieldVariableType === 'date'"
          >
            <el-date-picker
              v-model="form[data.key]"
              :placeholder="data.placeholder"
              @change="applyFormRules"
              :disabled="checkReadonly()"
              :style="getStyle"
              type="date"
              format="MM-dd-yyyy"
            />
          </template>
          <template
            v-else-if="data.integration_settings.selectedIntegrationFieldVariableType === 'text'"
          >
            <el-input
              v-model="form[data.key]"
              :placeholder="data.placeholder"
              @change="applyFormRules"
              :disabled="checkReadonly()"
              :suffix-icon="data.properties.el_icon"
              :style="getStyle"
            />
          </template>
          <template
            v-else-if="
              data.integration_settings.selectedIntegrationFieldVariableType === 'multilineText'
            "
          >
            <el-input
              v-model="form[data.key]"
              :placeholder="data.placeholder"
              @change="applyFormRules"
              :disabled="checkReadonly()"
              :suffix-icon="data.properties.el_icon"
              :style="getStyle"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 30 }"
            />
          </template>
          <template v-else>
            <el-select
              v-model="form[data.key]"
              placeholder="Select an option"
              @change="applyFormRules"
              :disabled="checkReadonly()"
              :style="getStyle"
            >
              <el-option
                v-if="data.is_entity_field && form[data.key + '/name'] && form[data.key]"
                :label="form[data.key + '/name']"
                :value="form[data.key]"
              ></el-option>
            </el-select>
          </template>
          <span v-if="isActive || isDataTableField" class="setting-icon" @click="openSettings">
            <i class="el-icon-s-tools" />
          </span>
        </div>
        <div v-else>
          <span
            v-if="this.data.integration_settings.selectedIntegrationFieldVariableType === 'select'"
          >
            {{ form[this.data.key + '/actualRecord'] }}
          </span>
          <span v-else>
            {{ form[this.data.key] | globalDateFormat }}
          </span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import * as moment from 'moment';
  import { mapGetters } from 'vuex';
  export default {
    components: {},
    props: [
      'data',
      'label',
      'value',
      'isActive',
      'isDataTableField',
      'isInDataTable',
      'colorFields',
      'form',
      'fromRepeatable',
      'fieldsData',
      'entityDataId',
      'checkIsDisabled',
      'entityId',
      'isHideField',
      'highlight',
      'fromEntityViews',
      'isView',
      'hasLabel',
      'integrationData',
      'filteredIntegrationVariableFields',
      'selectedIntegrationRecord',
      'labelAlignments',
      'integrations',
    ],
    computed: {
      ...mapGetters('userIntegrations', ['getrequiredFields']),
      computedSelectValue: {
        get() {
          const currentValue = this.form[this.data.key];
          const found = (this.integrationVariables || []).find(
            (item) => item.value === currentValue
          );
          return found ? found.value : '';
        },
        set(newValue) {
          this.$set(this.form, this.data.key, newValue);
        },
      },
      computedStyles() {
        const styles = {};
        styles.display = 'flex';
        if (this.labelAlignments || this.data?.styles?.labelAlignments) {
          styles.justifyContent = this.labelAlignments || this.data?.styles?.labelAlignments;
        }
        return styles;
      },
      getStyle() {
        return `height:${this.data.height - 30}px;`;
      },
      getElementStyle() {
        let borderStyle = '';
        if (this.data.styles) {
          let type = this.data.styles.border_type ? this.data.styles.border_type : 'solid';
          let size = this.data.styles.border_size ? this.data.styles.border_size + 'px' : '0px';
          let color = this.data.styles.border_color ? this.data.styles.border_color : '';
          let font_size =
            this.data.styles && this.data.styles.font && this.data.styles.font.font_size
              ? this.data.styles.font.font_size
              : 14;
          let bold =
            this.data.styles &&
            this.data.styles.font &&
            (this.data.styles.font.style == 1 || this.data.styles.font.style == 3)
              ? 'bold'
              : '';
          let italic =
            this.data.styles &&
            this.data.styles.font &&
            (this.data.styles.font.style == 2 || this.data.styles.font.style == 3)
              ? 'italic'
              : '';

          borderStyle = 'border:' + type + ' ' + size + ' ' + color;

          borderStyle += ';';
          borderStyle += this.data.styles.background
            ? `background: ${this.data.styles.background}`
            : '';
          borderStyle += ';';
          borderStyle += 'font-size:' + font_size + 'px;';
          if (bold) {
            borderStyle += 'font-weight:' + bold + ';';
          }
          if (italic) {
            borderStyle += 'font-style:' + italic + ';';
          }
          borderStyle += this.data.styles.label_color
            ? `color: ${this.data.styles.label_color}`
            : '';
          borderStyle += ';';
        }
        return borderStyle;
      },
      isDefalutPosq() {
        return this.data.styles && this.data.styles.labelStyle !== 'right';
      },
    },
    data() {
      return {
        requiredFieldCache: {},
        validations: [],
        options: [],
        showLabel: true,
        selectedValue: this.data.key,
        loading: false,
        integrationVariables: [],
        integrationVariablesObj: {},
        integrationVariablesCache: {},
        loadingFields: {},
      };
    },
    watch: {
      integrationData: {
        deep: true,
        immediate: true,
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.waitForIntegrationVariables().then(() => {
              this.syncInitialSelectValue();
            });
          }
        },
      },
      selectedIntegrationRecord: {
        deep: true,
        immediate: true,
        async handler(newVal) {
          if (newVal) {
            await this.getRequiredData();
            await this.waitForIntegrationVariables();
            await this.$nextTick();
            this.syncInitialSelectValue();
            await this.handleFormChange(newVal);
          }
        },
      },
    },
    async mounted() {
      if (!this.isView) {
        await this.getRequiredData();
        await this.waitForIntegrationVariables();
        this.syncInitialSelectValue();
      } else {
        const type = this.data.integration_settings.selectedIntegrationFieldVariableType;
        const value = this.form[this.data.key];

        if (type == 'date' && value) {
          const dateFormatted = moment(value).format('YYYY-MM-DD');
          this.$set(this.form, this.data.key, dateFormatted);
        }

        if (type == 'select' && value) {
          const match = (this.integrationVariables || []).find((item) => item.value === value);
          if (match) {
            this.$set(this.form, `${this.data.key}/actualRecord`, match.label);
          }
        }
      }
    },
    methods: {
      async waitForIntegrationVariables(maxRetries = 5, interval = 50) {
        let retries = 0;
        while (this.integrationVariables.length === 0 && retries < maxRetries) {
          await new Promise((resolve) => setTimeout(resolve, interval));
          retries++;
        }
      },
      syncInitialSelectValue() {
        const value = this.form[this.data.key];
        if (
          this.data.integration_settings.selectedIntegrationFieldVariableType === 'select' &&
          value
        ) {
          const match = this.integrationVariables.find((item) => item.value === value);
          if (match) {
            this.$set(this.form, `${this.data.key}/actualRecord`, match.label);
          }
        }
      },
      checkReadonly() {
        if (this.checkIsDisabled) {
          return true;
        }
        if (
          this.data &&
          this.data.properties &&
          this.data.properties.filed_content === 'DISABLED'
        ) {
          return true;
        }
        if (
          this.data &&
          this.data.properties &&
          this.data.properties.filed_content === 'READ ONLY'
        ) {
          return true;
        }
      },
      applyFormRules(value) {
        if (value && !this.isView) {
          let calVal = (this.integrationVariables || []).find((e) => e.value == value);
          this.$set(this.form, `${this.data.key}/actualRecord`, calVal.label);
          this.$set(this.form, this.data.key, calVal.value);
          if (calVal && calVal.cal_value !== undefined) {
            this.$set(this.form, `${this.data.key}/integrationCalvalue`, calVal.cal_value);
          }
        } else {
          this.$set(this.form, this.data.key, this.calVal?.value);
        }
        this.$emit('applyFormRules');
      },
      copyDocument() {
        this.$emit('copy-document', this.data.key);
      },
      openSettings() {
        this.$emit('settings');
      },
      async handleFormChange() {
        try {
          const fieldKey = this.data.key;
          const integrationFieldVariable =
            this.data.integration_settings?.selectedIntegrationFieldVariable;
          const fieldType = this.data.integration_settings?.selectedIntegrationFieldVariableType;
          const value = this.selectedIntegrationRecord?.[integrationFieldVariable];
          const parentIntegrationFieldKey =
            this.data.integration_settings?.selectedIntegrationField;
          if (
            this.selectedIntegrationRecord &&
            this.selectedIntegrationRecord._fromIntegrationField !== parentIntegrationFieldKey
          ) {
            return;
          }
          if (value === undefined || value === null) return;
          if (fieldType === 'select') {
            const match = this.integrationVariables.find((item) => item.value == value);
            if (match) {
              this.$set(this.form, fieldKey, match.value);
              this.$set(this.form, `${fieldKey}/actualRecord`, match.label);
              if (match.cal_value !== undefined) {
                this.$set(this.form, `${fieldKey}/integrationCalvalue`, match.cal_value);
              }
            }
          } else if (fieldType === 'date') {
            const formatted = moment(value).format('YYYY-MM-DD');
            this.$set(this.form, fieldKey, formatted);
            this.$set(this.form, `${fieldKey}/actualRecord`, formatted);
          } else if (fieldType === 'text' || fieldType === 'multilineText') {
            this.$set(this.form, fieldKey, value);
          }

          this.$emit('applyFormRules');
        } catch (err) {
          console.error('handleFormChange error:', err);
        }
      },
      async getRequiredData() {
        try {
          const fieldKey = this.data.key;
          if (this.loadingFields[fieldKey]) {
            return;
          }
          if (this.integrationVariablesCache[fieldKey]) {
            this.integrationVariables = this.integrationVariablesCache[fieldKey];
            return;
          }
          if (this.integrationVariables.length > 0) return;
          let integrationField = this.data.integration_settings.selectedIntegrationField;
          let integrationFieldDetails = this.fieldsData.find(
            (field) => field.key == integrationField
          );
          let event = integrationFieldDetails.integration_settings.selectedEvent;
          let app = this.integrations?.application.key;
          let eventsArray = this.integrations?.application.events;
          let integratioEvent = eventsArray.find(
            (selectedEvent) => String(selectedEvent._id) === event
          );
          let variableEvent = eventsArray.find(
            (event) => event.asset === integratioEvent.settings.eachRecordByEvent
          );
          let connection;
          if (integrationFieldDetails.integration_settings.selectedIntegration) {
            connection = integrationFieldDetails.integration_settings.selectedIntegration;
          } else {
            let templateDependencies =
              integrationFieldDetails.integration_settings.templateDependencies;
            templateDependencies.forEach((dep) => {
              let fieldData = this.fieldsData.find((field) => field.key === dep);
              if (fieldData.integration_settings.selectedIntegration) {
                connection = fieldData.integration_settings.selectedIntegration;
              }
            });
          }
          if (variableEvent && variableEvent.settings && variableEvent.settings.availableColumns) {
            let allColumns = variableEvent.settings.availableColumns;
            let columnFound = allColumns.find(
              (selectedColumn) =>
                String(selectedColumn.key) ===
                this.data.integration_settings.selectedIntegrationFieldVariable
            );
            if (columnFound && columnFound.isApiData) {
              const shouldLoad = columnFound.loadRequiredData !== false;
              if (!shouldLoad) {
                return;
              }
              let requiredData = {};
              let detailKey = columnFound.requiredAsset;
              const cacheKey = `${connection}::${detailKey}::${JSON.stringify(requiredData)}`;
              const cachedData =
                this.$store.getters['UserIntegrations/getRequiredFields'](cacheKey);
              if (cachedData) {
                this.integrationVariables = cachedData.data.map((variable) => {
                  this.integrationVariablesObj[variable.id] = variable.name;
                  return {
                    label: variable.name,
                    value: variable.id,
                    cal_value: variable.value,
                  };
                });
                this.integrationVariablesCache[fieldKey] = this.integrationVariables;
                return;
              }
              let requestBody = {
                selectedApplication: app,
                selectedEvent: detailKey,
                selectedIntegration: connection,
                requiredFields: requiredData,
              };
              let response = await this.$store.dispatch(
                'UserIntegrations/fetchRequiredFieldData',
                requestBody
              );
              this.integrationVariables = response.data.map((variable) => {
                this.integrationVariablesObj[variable.id] = variable.name;
                return {
                  label: variable.name,
                  value: variable.id,
                  cal_value: variable.value,
                };
              });
              this.integrationVariablesCache[fieldKey] = this.integrationVariables;
            }
          }
        } catch (err) {
          return err;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-select {
    width: 100% !important;

    .el-input,
    .el-input__inner {
      height: inherit !important;
    }
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }

  ::v-deep .el-col-20,
  .el-col-24 {
    width: 100% !important;
  }
</style>
